// Human labels for the TPRM request fields, grouped the way they appear on the
// request form. Used to render "Required information" as a plain checklist so
// legal never has to know the underlying field keys.
//
// Mirrors the fields in features/requests/RequestFormSteps.js — keep in sync if
// the request form gains/loses fields. Unknown keys still render (humanized).
export const REQUEST_FIELD_GROUPS = [
  {
    title: 'Vendor',
    fields: [
      ['vendorName', 'Vendor name'],
      ['vendorWebsite', 'Vendor website / domain'],
      ['vendorContactName', 'Vendor contact name'],
      ['vendorEmail', 'Vendor email'],
      ['vendorAddress', 'Vendor address'],
    ],
  },
  {
    title: 'Engagement',
    fields: [
      ['lightsparkEntity', 'Lightspark entity'],
      ['serviceOwner', 'Service owner'],
      ['scope', 'Scope of services'],
      ['serviceDescription', 'Service description'],
      ['agreementType', 'Agreement type'],
      ['vendorForm', 'On the vendor’s paper?'],
    ],
  },
  {
    title: 'Risk profile',
    fields: [
      ['customerInteraction', 'Interacts with our customers?'],
      ['criticalToOperations', 'Critical to operations?'],
      ['relatedParty', 'Related party?'],
      ['riskRating', 'Requester’s risk estimate'],
    ],
  },
  {
    title: 'Data & access',
    fields: [
      ['confidentialInfoShared', 'Confidential info shared?'],
      ['dataTypes', 'Data shared / processed'],
      ['dataAccessLevel', 'Data access level'],
      ['systemAccess', 'System access'],
      ['systemAccessDescription', 'System access details'],
      ['dataRetention', 'Data retention / deletion'],
    ],
  },
  {
    title: 'AI & IP',
    fields: [
      ['aiMlUsage', 'Uses AI/ML?'],
      ['aiTrainingUse', 'Trains on Lightspark data?'],
      ['aiCodeOrIpGeneration', 'Generates code / IP?'],
      ['ipProduction', 'Produces IP?'],
    ],
  },
  {
    title: 'NDA, fees & term',
    fields: [
      ['ndaStatus', 'NDA status'],
      ['estimatedFees', 'Estimated fees'],
      ['feeFrequency', 'Fee frequency'],
      ['expenseReimbursement', 'Expense reimbursement?'],
      ['requiresCeoApproval', 'Requires CEO approval?'],
      ['ceoApprovalEvidence', 'CEO approval evidence'],
      ['startDate', 'Start date'],
      ['endDate', 'End date'],
      ['notes', 'Additional notes'],
    ],
  },
];

// key -> label, flattened.
export const REQUEST_FIELD_LABELS = REQUEST_FIELD_GROUPS.reduce((acc, g) => {
  g.fields.forEach(([key, label]) => { acc[key] = label; });
  return acc;
}, {});

// Fallback for keys not in the registry: "customerInteraction" -> "Customer interaction".
export function humanizeFieldKey(key) {
  if (REQUEST_FIELD_LABELS[key]) return REQUEST_FIELD_LABELS[key];
  const spaced = String(key || '')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .trim();
  return spaced ? spaced.charAt(0).toUpperCase() + spaced.slice(1) : key;
}
